import * as React from 'react';
import { SelectSingle } from 'app/area/shared/translated-components';
import { ChangeOwnerFieldProps, ChangeOwnerField } from 'app/area/favourite-administration/list/change-owner/types';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { endpoints } from 'app/area/favourite-administration/form/endpoints';
import { FavouriteListIds } from 'app/area/favourite-administration/list/constants';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const Owner = (props: ChangeOwnerFieldProps) => {
  const { list: { changeOwner: { form, validation } = {} }, options, translation,
    loadOptions, updateByKey, resetValidation } = props;

  const fieldKey = ChangeOwnerField.owner;
  const valueItem = form?.[fieldKey];

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(FavouriteListIds.owner);
    updateByKey(fieldKey, value);
  };

  const onOwnerLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(FavouriteListIds.owner, endpoints.ownerOptions, loadOptionsParams);
  };

  return <SelectSingle
      componentId={FavouriteListIds.owner}
      className={'w-100'}
      valueItem={valueItem}
      label={{ text: translation.owner, visible: true, required: true }}
      options={options?.[FavouriteListIds.owner]?.codes as ComplexValue<number>[] || []}
      placeholder={translation?.search}
      fetching={options?.[FavouriteListIds.owner]?.fetching}
      onLoadOptions={onOwnerLoadOptions}
      onChange={onChange}
      validation={validation?.owner} />;
};
